import { useCallback, useState } from 'react';
import { DataKYCFileTctWithFile, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';

interface Props {
	filesForStep?: DataKYCFileTctWithFile[];
	currentInvestor?: GetKYCInvestorInstanceRes | undefined;
	selectedKycFile?: DataKYCFileTctWithFile | undefined;
}

export const useScrollFileCard = ({ filesForStep, currentInvestor, selectedKycFile }: Props) => {
	const [fileListScrollDirection, setFileListScrollDirection] = useState<'left' | 'right' | null>(
		null
	);

	const scrollFileCard = useCallback(
		(direction: 'left' | 'right') => {
			if (!filesForStep) {
				return false;
			}

			const currentFileIndex = filesForStep.findIndex(
				(file) => file.file.id === selectedKycFile?.file.id
			);

			if (!currentInvestor?.kycFiles) {
				return false;
			}
			if (direction === 'right') {
				if (filesForStep.length > 1 && currentFileIndex < filesForStep.length - 1) {
					setFileListScrollDirection('right');
					return true;
				}
			} else if (direction === 'left') {
				if (filesForStep.length > 1 && currentFileIndex > 0) {
					setFileListScrollDirection('left');
					return true;
				}
			}
			return false;
		},
		[
			filesForStep,
			selectedKycFile?.file.id,
			currentInvestor?.kycFiles,
			setFileListScrollDirection,
		]
	);

	return { scrollFileCard, fileListScrollDirection, setFileListScrollDirection };
};
